import React, { useEffect, useState } from 'react';
import { text } from '../../../../utils/text';
import { Action, Risikoprofil, RoutePath, Spareformål } from '../../../../utils/types';
import { useForm } from 'react-hook-form';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Card } from '../../../common/Card/Card';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import * as yup from 'yup';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Form } from '../../../common/Form/Form';
import { Layout } from '../../../common/Layout/Layout';
import { useFormContext } from '../../../../context/FormContext';
import { InputGroupSimple } from '../../../common/Form/InputGroupSimple';
import styles from './profil.module.less';
import { GroupOptionIllustration } from '../../../common/InputOptionIllustration/Illustration';
import { CriticalButton, SecondaryButton } from '@gjensidige/core-buttons';
import { Modal } from '@gjensidige/core-modal';
import { Title } from '@gjensidige/core-typography';
import { AdditionalInfoAlert } from '../../../common/InfoAlert/AdditionalInfoAlert';
import { LOGGER_ENDPOINT, putChosenProfile } from '../../../../utils/api';
import { remoteLogError } from '@gjensidige/gpf-js-utils/es6/logging/error-handler';
import trygg from '../../../../../assets/images/profil_trygg.svg';
import balansert from '../../../../../assets/images/profil_balansert.svg';
import offensiv from '../../../../../assets/images/profil_offensiv.svg';
import alderstilpasset from '../../../../../assets/images/profil_alderstilpasset.svg';
import { Pill } from '@gjensidige/core-pill';
import { getFondskategoriFordeling } from '../../../../utils/utils';
export const ProfilForm = () => {
    const [{ profildata, risikoanbefaling, raadgivningData, kontoopplysninger, porteføljedata }, dispatch] = useFormContext();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { state } = useLocation();
    const history = useHistory();
    const { handleSubmit, control, trigger, getValues } = useForm({
        resolver: yupResolver(profileValidationSchema),
        defaultValues: { profile: profildata === null || profildata === void 0 ? void 0 : profildata.profile },
        mode: 'onChange',
    });
    useEffect(() => {
        trackScenario(scenarioSteps.FUND_PROFILE);
    }, []);
    const submit = (data) => data.profile === (risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling.risikoprofil) ? submitProfil(data.profile) : setShowConfirmModal(true);
    const raadgivningRef = raadgivningData === null || raadgivningData === void 0 ? void 0 : raadgivningData.ref;
    if (!raadgivningRef || !risikoanbefaling || !porteføljedata) {
        return React.createElement(Redirect, { to: RoutePath.RAADGIVNING_EGNETHET });
    }
    const submitProfil = (profil) => {
        trigger('profile').then((isValid) => {
            if (isValid && profil) {
                setSubmitting(true);
                setShowConfirmModal(false);
                putChosenProfile(raadgivningRef, profil).then((result) => {
                    if (result.isOk()) {
                        dispatch({
                            type: Action.SUBMIT_VALGT_RISIKOPROFIL,
                            risikoprofil: { profile: profil, isAnbefaltProfil: profil === risikoanbefaling.anbefaling.risikoprofil },
                        });
                        nextStep();
                    }
                    else if (result.isErr()) {
                        setSubmitting(false);
                        void remoteLogError(LOGGER_ENDPOINT, new Error(result.error.message));
                    }
                });
            }
        });
    };
    const beholdAnbefaltProfil = () => {
        dispatch({
            type: Action.SUBMIT_VALGT_RISIKOPROFIL,
            risikoprofil: { profile: risikoanbefaling.anbefaling.risikoprofil, isAnbefaltProfil: true },
        });
        nextStep();
    };
    const nextStep = () => {
        (state === null || state === void 0 ? void 0 : state.isEdit) ? history.push(RoutePath.SUMMARY) : history.push(RoutePath.RAADGIVNING_FATCA);
    };
    const options = getProfileOptions(risikoanbefaling.anbefaling.risikoprofil, porteføljedata, kontoopplysninger.spareformål);
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 4, title: text.FORM.PROFILE_FORM.TITLE.no, subtitle: text.FORM.PROFILE_FORM.DESCRIPTION.no },
            React.createElement(Form, { onSubmit: handleSubmit(submit) },
                React.createElement(InputGroupSimple, { name: "profile", id: "profile", type: "radio", options: options, control: control, className: 'whitespace-wrap', centered: false, dividers: true }),
                React.createElement(AdditionalInfoAlert, { text: text.FORM.PROFILE_FORM.FRITT_FONDSVALG_INFO.no }),
                React.createElement(NavigationButtons, { onPrevious: () => history.push(RoutePath.ANBEFALT_PROFIL), nextText: (state === null || state === void 0 ? void 0 : state.isEdit) ? text.NAV_BUTTONS.SAVE.no : text.NAV_BUTTONS.NEXT.no, loading: submitting, isSubmit: true }))),
        React.createElement(ConfirmProfileModal, { visible: showConfirmModal, onBekreft: () => submitProfil(getValues('profile')), onBeholdAnbefalt: beholdAnbefaltProfil, onClose: () => setShowConfirmModal(false) })));
};
const profileValidationSchema = yup.object().shape({
    profile: yup.string().required(text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.VALIDATION.REQUIRED.no),
});
const ProfileOptionDescription = ({ description, illustration, erAnbefaltProfil }) => {
    return (React.createElement("div", { className: styles.option },
        React.createElement("div", { className: styles.description },
            React.createElement("div", null, description),
            erAnbefaltProfil && (React.createElement(Pill, { className: styles.pill, color: 'green' }, text.FORM.PROFILE_FORM.ANBEFALT_PROFIL_PILL.no))),
        React.createElement(GroupOptionIllustration, { src: illustration })));
};
const ConfirmProfileModal = ({ onBekreft, onBeholdAnbefalt, onClose, visible }) => {
    return (React.createElement(Modal, { onClick: onClose, visible: visible, ariaLabel: text.FORM.PROFILE_FORM.BEKREFT_MODAL.ARIA_LABEL.no, ariaLabelCloseButton: text.FORM.PROFILE_FORM.BEKREFT_MODAL.ARIA_LABEL_CLOSE.no, contentClassName: styles.confirmModal },
        React.createElement("section", { className: styles.header },
            React.createElement(Title, { tag: 'h2', size: 'h4' }, text.FORM.PROFILE_FORM.BEKREFT_MODAL.TITLE.no)),
        React.createElement("section", { className: styles.confirmBtnGroup },
            React.createElement(CriticalButton, { onClick: onBekreft }, text.FORM.PROFILE_FORM.BEKREFT_MODAL.BEKREFT.no),
            React.createElement(SecondaryButton, { onClick: onBeholdAnbefalt }, text.FORM.PROFILE_FORM.BEKREFT_MODAL.AVBRYT.no))));
};
const getProfileOptions = (anbefaltProfil, porteføljedata, spareformål) => {
    const defaultOptions = [
        {
            value: Risikoprofil.TRYGG,
            label: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.TRYGG.TITLE.no,
            description: (React.createElement(ProfileOptionDescription, { description: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.TRYGG.DESCRIPTION_WITH_ALLOCATION(getFondskategoriFordeling(porteføljedata[Risikoprofil.TRYGG])).no, illustration: trygg, erAnbefaltProfil: anbefaltProfil === Risikoprofil.TRYGG })),
            className: styles.fullWidthOption,
        },
        {
            value: Risikoprofil.BALANSERT,
            label: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.BALANSERT.TITLE.no,
            description: (React.createElement(ProfileOptionDescription, { description: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.BALANSERT.DESCRIPTION_WITH_ALLOCATION(getFondskategoriFordeling(porteføljedata[Risikoprofil.BALANSERT])).no, illustration: balansert, erAnbefaltProfil: anbefaltProfil === Risikoprofil.BALANSERT })),
            className: styles.fullWidthOption,
        },
        {
            value: Risikoprofil.OFFENSIV,
            label: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.OFFENSIV.TITLE.no,
            description: (React.createElement(ProfileOptionDescription, { description: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.OFFENSIV.DESCRIPTION_WITH_ALLOCATION(getFondskategoriFordeling(porteføljedata[Risikoprofil.OFFENSIV])).no, illustration: offensiv, erAnbefaltProfil: anbefaltProfil === Risikoprofil.OFFENSIV })),
            className: styles.fullWidthOption,
        },
    ];
    const showAldersilpasset = anbefaltProfil === Risikoprofil.OFFENSIV || spareformål === Spareformål.PENSJON;
    if (showAldersilpasset) {
        const alderstilpassetOption = {
            value: Risikoprofil.ALDERSTILPASSET,
            label: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.TITLE.no,
            description: (React.createElement(ProfileOptionDescription, { description: text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.DESCRIPTION_WITH_ALLOCATION().no, illustration: alderstilpasset, erAnbefaltProfil: anbefaltProfil === Risikoprofil.ALDERSTILPASSET })),
            className: styles.fullWidthOption,
        };
        return [...defaultOptions, alderstilpassetOption];
    }
    else {
        return defaultOptions;
    }
};
